export enum SchedulerComponents {
  'Empty' = 'empty',
  'Open' = 'open',
  'Closed' = 'closed',
  'OpenFullTime' = 'openFullTime',
}
